/* tslint:disable */
/* eslint-disable */
/* @relayHash aae63014db06ebc085403a2d8b5a42a8 */

import { ConcreteRequest } from "relay-runtime";
export type SetEmailInput = {
    email: string;
    clientMutationId: string;
};
export type SetEmailMutationVariables = {
    input: SetEmailInput;
};
export type SetEmailMutationResponse = {
    readonly setEmail: {
        readonly user: {
            readonly email: string | null;
        };
        readonly clientMutationId: string;
    };
};
export type SetEmailMutation = {
    readonly response: SetEmailMutationResponse;
    readonly variables: SetEmailMutationVariables;
};



/*
mutation SetEmailMutation(
  $input: SetEmailInput!
) {
  setEmail(input: $input) {
    user {
      email
      id
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SetEmailMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetEmailPayload",
                    "kind": "LinkedField",
                    "name": "setEmail",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoralUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SetEmailMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetEmailPayload",
                    "kind": "LinkedField",
                    "name": "setEmail",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "CoralUser",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "aae63014db06ebc085403a2d8b5a42a8",
            "metadata": {},
            "name": "SetEmailMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '9d22b9ac878839bd30505594d45f4f4c';
export default node;
